import { doc, updateDoc } from 'firebase/firestore'
import { api } from './api'
//import { sendEmailVerification } from 'firebase/auth'

export async function sendVerificationEmail(
  firestore,
  functions,
  currentUser,
  searchParams
) {
  const queryString = searchParams.toString()
  const continueUrl =
    import.meta.env.VITE_APP_ROOT +
    (queryString ? '?' + queryString : '') +
    '#emailVerified'
  await api(functions, 'users/verify_email', {
    email: currentUser.email,
    continueUrl: continueUrl,
  })

  await updateDoc(doc(firestore, 'userprofiles', currentUser.uid), {
    emailVerificationSent: true,
  })

  //await sendEmailVerification(currentUser, { url: continueUrl })
}
